import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function CoinsEye({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M12 21.5C9.48044 21.5 7.06408 20.4991 5.28249 18.7175C3.50089 16.9359 2.5 14.5196 2.5 12C2.5 9.48044 3.50089 7.06408 5.28249 5.28249C7.06408 3.50089 9.48044 2.5 12 2.5C14.5196 2.5 16.9359 3.50089 18.7175 5.28249C20.4991 7.06408 21.5 9.48044 21.5 12M10.4331 10.3986C10.641 8.86347 12.0562 7.80005 13.5914 8.00794C15.1186 8.21582 16.182 9.63105 15.9741 11.1662C15.7982 12.3975 14.8227 13.373 13.5834 13.5489M18.879 18.4009C18.929 18.4509 18.929 18.5409 18.879 18.6009C18.819 18.6509 18.729 18.6509 18.669 18.6009C18.609 18.5409 18.609 18.4509 18.669 18.3909C18.719 18.3309 18.809 18.3309 18.869 18.3909M10.8009 10.3986C10.0587 10.3986 9.34691 10.6935 8.82209 11.2183C8.29728 11.7431 8.00244 12.4549 8.00244 13.1971C8.00244 13.9393 8.29728 14.6511 8.82209 15.1759C9.34691 15.7007 10.0587 15.9956 10.8009 15.9956C11.5431 15.9956 12.2549 15.7007 12.7797 15.1759C13.3045 14.6511 13.5994 13.9393 13.5994 13.1971C13.5994 12.4549 13.3045 11.7431 12.7797 11.2183C12.2549 10.6935 11.5431 10.3986 10.8009 10.3986ZM15.26 19.19C14.98 18.77 14.98 18.22 15.26 17.81C16.1 16.52 17.44 15.49 18.773 15.49C20.103 15.49 21.4331 16.51 22.2831 17.8C22.5531 18.21 22.5531 18.76 22.2831 19.18C21.4331 20.462 20.0931 21.49 18.7631 21.49C17.4231 21.49 16.093 20.46 15.25 19.18L15.26 19.19Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default CoinsEye;